import Bao from "./../../services/bao-service";
import * as ko from "knockout";

/*
 * View model for advanced printing dialog
 * */
class AdvancedPrintingDialog {

    Parent: any;
    ReportTabs: KnockoutObservableArray<any> = ko.observableArray([]);
    RelevantShiftInformations: KnockoutObservable<string> = ko.observable("true");
    ExportVersion: KnockoutObservable<string> = ko.observable("revision");

    ReportLayoutId: KnockoutObservable<string> = ko.observable();
    ReportLayoutIds: KnockoutObservableArray<string> = ko.observableArray([]);
    ReportLayouts: KnockoutObservableArray<any> = ko.observableArray([]);
    ReportLayoutName: KnockoutObservable<string> = ko.observable();

    LayoutSearcher: any;

    constructor(parent: any) {
        this.Parent = parent;
        this.LayoutSearcher = {
            SearchType: "ReportLayout",
            ObjectId: this.ReportLayoutId,
            ObjectValue: "Name",
            AutoComplete: true,
            AutoSearch: true,
            Items: this.ReportLayouts,
            //CustomFilter: { reportId: this.Parent.ReportId() }
        };
        this.init();
    }

    init() {
        this.ReportLayoutId.subscribe(value => {
            this.ReportLayoutIds([value]);
        });
        this.getUniversalReportMetaData();
    }

    /*
     * Sets values for view model from metadata (saved values in db)
     * */
    getUniversalReportMetaData() {
        this.Parent.TabPage.IsLoading(true);
        Bao.post("ShiftReport/GetAdvancedPrintingDialogMetaData", JSON.stringify({
            reportId: this.Parent.ReportId()
        })).then(result => {
            this.ReportTabs(result.ReportTabs);
            this.ReportLayoutIds(result.ReportLayoutIds);
            if (result.ReportLayoutIds) {
                this.ReportLayouts(result.ReportLayouts);
                if (result.ReportLayoutName) {
                    this.ReportLayoutName(result.ReportLayoutName);
                }
            }
            if (result.RelevantShiftInformations) {
                this.RelevantShiftInformations(result.RelevantShiftInformations);
            }
            if (result.ExportVersion) {
                this.ExportVersion(result.ExportVersion);
            }

            this.Parent.TabPage.IsLoading(false);
        });
    }

    /*
     * Saving metadata in db
     * */
    setUniversalReportMetaData() {
        this.Parent.TabPage.IsLoading(true);
        return Bao.post("ShiftReport/SaveAdvancedPrintingMetaData", JSON.stringify({
            reportTabs: this.ReportTabs().filter(x => x.IsSelected).map(x => x.TabName).join(";"),
            universalreportlayoutIds: this.ReportLayoutIds(),
            relevantShiftInformations: this.RelevantShiftInformations(),
            exportVersion: this.ExportVersion()
        })).then(() => {
            this.Parent.TabPage.IsLoading(false);
        });
    }
}
export default AdvancedPrintingDialog;